import { useCallback } from 'react';

import { useCookies } from '~/techstyle-shared/redux-core';

/**
 * Sets the sms-opt-in cookie to true or false, used in the Digioh "SMS Opt In Cookie"
 * rule set, which if set will block SMS pop ups from being shown to the user.
 * Reason for this is that the Iterable list for sms opt ins is slow to update,
 * so users might see the pop up despite having shared their phone number.
 * This cookie is set to expire in one hour. After it expires the Iterable list
 * will be synced and Digioh will use that logic again.
 *
 * setSMSOptInCookie - @param {boolean} optIn - whether the user shared their phone number
 */
export function useSMSOptInCookie() {
  const [, setCookie] = useCookies();

  const setSMSOptInCookie = useCallback(
    (optIn) => {
      const cookieExpirationTime = new Date(
        new Date().getTime() + 60 * 60 * 1000 // one hour
      );
      setCookie('sms-opt-in', optIn, {
        expires: cookieExpirationTime,
      });
    },
    [setCookie]
  );

  return { setSMSOptInCookie };
}
